/**
 * Labstep
 *
 * @module constants/post-filter
 * @desc Static configuration for POST Filters
 */

export const EXPERIMENT_WORKFLOW_POST_FILTER_URL_PARAMETERS = [
  'signature_request_user_id',
  'has_signature',
  'has_signature_request',
  'entity_state_name',
];
